import { Tooltip as ChakraTooltip, TooltipProps } from '@chakra-ui/react'

/**
 * Atraso de abertura, em ms. Só 12 dos 132 tooltips do painel passavam um, então dois vizinhos
 * da mesma tabela apareciam em tempos diferentes: o que tinha `openDelay` esperava, o que não
 * tinha abria na hora — e percorrer uma linha de ações com o mouse acendia meia dúzia de balões
 * em cascata.
 */
const TOOLTIP_OPEN_DELAY = 300

/**
 * Tooltip do painel. Era `<Tooltip>` do Chakra direto, em **132 usos, 59 arquivos e 12
 * assinaturas**: `hasArrow` em 87 e ausente em 45 — muitas vezes na mesma tela —, `placement`
 * explícito em 65 e no padrão em 67, `openDelay` em 12, e `fontSize` sobrescrito em 4.
 *
 * **Isto é um componente e não um `defaultProps` no `theme.ts`** — que é onde o `Badge`, as
 * `Tabs` e os três controles de liga/desliga moram — porque o `defaultProps` do Chakra só
 * alimenta o cálculo de estilo (`size`, `variant`, `colorScheme`). `hasArrow`, `placement` e
 * `openDelay` são comportamento: o `Tooltip` os lê das próprias props, e um `defaultProps` no
 * tema não os alcançaria. Aparência continua no tema; comportamento, aqui.
 *
 * `placement` fica como escape para o tooltip que o `top` colocaria fora da tela ou por cima do
 * que ele descreve — as setas do lightbox de obra, o botão de suporte no topo do `Header`, o
 * `ActionFab` no canto inferior direito.
 */
export default function Tooltip({
  hasArrow = true,
  placement = 'top',
  openDelay = TOOLTIP_OPEN_DELAY,
  ...rest
}: TooltipProps) {
  return <ChakraTooltip hasArrow={hasArrow} placement={placement} openDelay={openDelay} {...rest} />
}
